export const handleInsuranceUploadErrors = (error: string, errorCode: string) => {
  let uploadErrorMessage = '';
  switch (error && errorCode) {
    // MES codes relate to new expansion service endpoint
    case 'MES029':
      uploadErrorMessage = 'Attachment Guard Error';
      break;
    case 'MES030':
      uploadErrorMessage = 'Error extracting request in interceptor';
      break;
    case 'MES026':
      uploadErrorMessage = 'Cannot upload more than 1 file';
      break;
    case 'MES018':
      uploadErrorMessage = 'Size of file cannot be 0 bytes';
      break;
    case 'MES027':
      uploadErrorMessage = 'Cannot upload file of size > 10 mb';
      break;
    case 'MES024':
      uploadErrorMessage = 'Mime type is not supported';
      break;
    case 'MES023':
      uploadErrorMessage = 'Extension is not supported';
      break;
    case 'MES025':
      uploadErrorMessage = 'Special characters in fileName are not allowed';
      break;
    case 'MES015':
      uploadErrorMessage = 'Unable to upload and scan attachment';
      break;
    // AE codes relate to old service endpoint
    case 'AE001':
      uploadErrorMessage = 'Attachment Guard Error';
      break;
    case 'AE002':
      uploadErrorMessage = 'Error extracting request in interceptor';
      break;
    case 'AE003':
      uploadErrorMessage = 'Cannot upload more than 1 file';
      break;
    case 'AE004':
      uploadErrorMessage = 'Size of file cannot be 0 bytes';
      break;
    case 'AE006':
      uploadErrorMessage = 'Mime type is not supported';
      break;
    case 'AE007':
      uploadErrorMessage = 'Extension is not supported';
      break;
    case 'AE008':
      uploadErrorMessage = 'Special characters in fileName are not allowed';
      break;
    case 'AE009':
      uploadErrorMessage = 'Unable to upload and scan attachment';
      break;
    default:
  }
  return uploadErrorMessage;
};
